var map = {
	"./img1.jpg": 2415,
	"./img10.jpg": 2416,
	"./img2.jpg": 2417,
	"./img3.jpg": 2418,
	"./img4.jpg": 2419,
	"./img5.jpg": 2420,
	"./img6.jpg": 2421,
	"./img7.jpg": 2422,
	"./img8.jpg": 2423,
	"./img9.jpg": 2424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2414;